// TelcoTrack - Section tabs bridge
// Invisible directive on feature pages — registers contextual tabs with TopbarSectionTabsService.
// The app shell renders the current level in the sidebar (no longer in the top bar).

import {
  Directive,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  DestroyRef,
  inject,
} from '@angular/core';
import type { TabItem } from '../components/ui/tabs/tabs.component';
import { TopbarSectionTabsService } from '../../core/services/topbar-section-tabs.service';

@Directive({
  selector: '[ttTopbarSectionTabs]',
})
export class TopbarSectionTabsDirective implements OnChanges {
  private readonly ownerId = Symbol('topbar-section-tabs');
  private readonly topbarTabs = inject(TopbarSectionTabsService);
  private readonly destroyRef = inject(DestroyRef);

  /** Tab definitions — bound via `[ttTopbarSectionTabs]="tabs"`. */
  @Input('ttTopbarSectionTabs') tabs: TabItem[] = [];
  @Input() ttTopbarSectionTabsActiveId = '';
  @Input() ttTopbarSectionTabsAriaLabel = '';
  @Input() ttTopbarSectionTabsIdPrefix = 'tt-topbar-tab';
  @Input() ttTopbarSectionTabsVisible = true;

  @Output() ttTopbarSectionTabsActiveIdChange = new EventEmitter<string>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.topbarTabs.unregisterRow(this.ownerId);
    });
  }

  ngOnChanges(): void {
    this.topbarTabs.registerRow({
      ownerId: this.ownerId,
      tabs: this.tabs,
      activeId: this.ttTopbarSectionTabsActiveId,
      ariaLabel: this.ttTopbarSectionTabsAriaLabel,
      idPrefix: this.ttTopbarSectionTabsIdPrefix,
      visible: this.ttTopbarSectionTabsVisible,
      onActiveIdChange: (tabId) => this.ttTopbarSectionTabsActiveIdChange.emit(tabId),
    });
  }
}
